<template>
  <div v-if="isUsStore">
    <a class="idd_mil desktop-navigation__link">
      {{ strings.militaryDiscountCta }}
    </a>
  </div>
  <a
    :href="`${routes.rootUrl}checkout`"
    class="btn--black"
  >
    <!-- having a class of "btn" stops the amount updating - :melt-face: -->
    {{ strings.checkout }} - {{ totalPrice }}
  </a>
</template>

<script>
import { productPrice } from '../../helpers/product'

export default {
  props: {
    cartTotalPrice: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      strings: { ...window.theme.cart.strings },
      routes: {...window.theme.cart.routes},
    }
  },
  computed: {
    totalPrice () {
      return productPrice(this.cartTotalPrice)
    },
    isUsStore () {
      return window.theme.shop.permanentDomain === 'sneak-gaming.myshopify.com'
    }
  }
}
</script>
